import type { ContactInputDto, ProviderDto, ProviderInputDto, ProviderPagedRequestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  apiName = 'Default';
  

  addContactByInputDto = (inputDto: ContactInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/provider/contact',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  createByInputDto = (inputDto: ProviderInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/provider',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  deleteByProviderId = (providerId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/app/provider',
      params: { providerId },
    },
    { apiName: this.apiName,...config });
  

  editByInputDto = (inputDto: ProviderInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/provider/edit',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllByInput = (input: ProviderPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ProviderDto>>({
      method: 'GET',
      url: '/api/app/provider',
      params: { name: input.name, vatNumber: input.vatNumber, state: input.state, code: input.code, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getByIdByProviderId = (providerId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProviderDto>({
      method: 'GET',
      url: `/api/app/provider/by-id/${providerId}`,
    },
    { apiName: this.apiName,...config });
  

  removeContactByInputDto = (inputDto: ContactInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/app/provider/contact',
      params: { id: inputDto.id, email: inputDto.email, providerId: inputDto.providerId, actionId: inputDto.actionId },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
